import React from "react";
import decenter from "./images/decenter.jpg";

const Description = () => {
  return (
    <div className="bg-gradient-to-tl from-[#212445] via-[#212445] to-[#462E52]">
      <div className="lg:flex gap-20 md:px-28 px-4 py-2 lg:py-20">
        <div className=" w-full lg:mt-1 mt-6">
          <img src={decenter} className="w-full h-full rounded-2xl" />
        </div>
        <div className=" w-full ">
          <div>
            <h1 className=" mt-5 text-2xl font-semibold text-white">
              📄 Wills and Testaments:
            </h1>

            <h1 className="text-[#9EA0A1] text-sm py-5 text-justify lg:w-3/4">
              For parents, family members and next of kin to ensure
              beneficiaries have a central and secure storage locker for these
              important documents— with the privacy of keeping it concealed
              until you’re gone.
            </h1>
          </div>

          <div>
            <h1 className=" mt-5 text-2xl font-semibold text-white">
              🔒Records and Accounts:
            </h1>

            <h1 className="text-[#9EA0A1] text-sm py-5 text-justify lg:w-3/4">
              A single location (as backup) for important information, records
              and account info for easy retrieval from family members. Ensure
              they always have access to this vital information— encrypted and
              protected.
            </h1>
          </div>

          <div>
            <h1 className=" mt-5 text-2xl font-semibold text-white">
              🗃️Pictures, videos and media:
            </h1>

            <h1 className="text-[#9EA0A1] text-sm py-5 text-justify lg:w-3/4">
              Personalize your boxes for friends, loved ones, and even future
              offspring filled with the memories and stories you want to leave
              behind.
            </h1>
          </div>

          <div>
            <h1 className=" mt-5 text-2xl font-semibold text-white">
              👋 Parting words:
            </h1>

            <h1 className="text-[#9EA0A1] text-sm py-5 text-justify lg:w-3/4">
              Say the things you always wanted to say but may have been too
              awkward to share. Loved ones and family…an ex, estranged family
              member, or arch nemesis? Leave your final goodbyes behind,
              inaccessible until after you pass.
            </h1>
          </div>

          <div>
            <h1 className=" mt-5 text-2xl font-semibold text-white">
              🤫🎉Secrets and Surprises:
            </h1>

            <h1 className="text-[#9EA0A1] text-sm py-5 text-justify lg:w-3/4">
              Create fun boxes where anything goes to leave a lasting impression
              for the ones you want.{" "}
            </h1>
          </div>

          <div>
            <h1 className=" mt-5 text-lg font-normal text-white">
              Don’t wait for a rainy day…create and send your boxes today!
            </h1>
          </div>
        </div>
      </div>
      <img
        src="https://themegenix.net/wp/nerko/wp-content/uploads/2022/12/divider-01.svg"
        className="mx-auto py-10"
      />
    </div>
  );
};

export default Description;
